var copy = require('./extend');

var _util = require('./_util');

var reqMultipart = 'multipart/form-data;charset=UTF-8';

var userInfo = {}
// 区分环境字段
console.log('++++++++')
console.log(process.env.JUDGE_ENV)
console.log('++++++++')
console.log('新的呀')
var host = '';
var logHost = '';
var getProtocol = 'https:' || location.protocol
if (!/(http[s]{0,1}):/g.test(getProtocol)) {
    getProtocol = 'https:'
}
switch (process.env.JUDGE_ENV) {
    case 'release':
        host = getProtocol + '//passport.100tal.com/v1';
        logHost = getProtocol + '//ucdj.100tal.com';
        window.envString = '';
        break;
    case 'development':
        host = getProtocol + '//test-passport.100tal.com/v1';
        logHost = getProtocol + '//test-ucdj.100tal.com';
        window.envString = 'sandbox';
        break;
    case 'sandbox':
        host = getProtocol + '//test-passport.100tal.com/v1';
        logHost = getProtocol + '//test-ucdj.100tal.com';
        window.envString = 'sandbox';
        break;
    case 'production':
        host = getProtocol + '//passport.100tal.com/v1';
        logHost = getProtocol + '//ucdj.100tal.com';
        window.envString = 'prod';
        break;
}

var domain = 'xueersi.com'

var slideCallback, slideParams, slidefailCallback, isH5;

function getParams (params) {
    return _util.getParams(params)
}
let checkHeartbeatFlag = ''
let setHeartbeatFlag = ''
var TAL_UC = {
    /*
    * @discribe 用户注入方法
    * 都要写在这个方法之中
    * @method ready
    * @param {Function} 匿名函数方法
    * */
    rankConfig: function (options) {
        var newOptions = {
            'client-id': options['client-id'] || ''
        }
        userInfo = copy.extend(true, {}, userInfo, newOptions)
        _util.setHeader(userInfo)
        if (options.env) {
            switch (options.env) {
                case 'sandbox':
                    host = getProtocol + '//test-passport.100tal.com/v1';
                    logHost = getProtocol + '//test-ucdj.100tal.com';
                    break;
                case 'production':
                    host = getProtocol + '//passport.100tal.com/v1';
                    logHost = getProtocol + '//ucdj.100tal.com';
                    break;
                default:
                    host = getProtocol + '//passport.100tal.com/v1';
                    logHost = getProtocol + '//ucdj.100tal.com';
            }
        }
        /******设置心跳*********/
        this.setCheckHeartbeat();
        // 设置资源错误系统日志
        _util.sysLog(logHost)
    },
    /*
    * @discribe 用户获取一些header头基本信息的方法
    * @method getNeedInfo
    * @param {Function} 匿名函数方法
    * @return {Object} 返回一个对象
    * */
    getDeviceInfo(params) {
        params.success({
            errcode: 0,
            errmsg: '请求成功',
            data: {
                "device-id": _util.createdDeviceId()
            }
        });
    },
    /*
    * @discribe 初始化无痕验证。
    * @method configNVC
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象
    * */
    configNVC: function (configParams) {
        var _this = this
        var scene, appkey;
        // 初始化无痕验证
        if (configParams.isH5) {
            // H5页面
            scene = 'nvc_login_h5';
            isH5 = true;
            appkey = 'FFFF0N00000000007DA2';
        } else {
            // web页面
            scene = 'nvc_login';
            isH5 = false;
            appkey = 'FFFF0N00000000007DA2';
        }
        window.NVC_Opt = {
            //无痕配置 && 滑动验证、刮刮卡、问答验证码通用配置
            appkey: appkey,
            scene: scene,
            isH5: isH5,
            popUp:false,
            renderTo: configParams.renderToEle,
            nvcCallback:function(data){
                slideParams.data.invisible_sig = data
                slideParams.data.is_second_verify = 1
                if (_this[slideCallback]) {
                    _this[slideCallback](slideParams)
                } else {
                    slidefailCallback({errcode: 4000, errmsg: '方法名错误'})
                }
                // data为getNVCVal()的值，此函数为二次验证滑动或者刮刮卡通过后的回调函数
                // data跟业务请求一起上传，由后端请求AnalyzeNvc接口，接口会返回100或者900
            },
            // trans: {"nvcCode":400,"key1": "code0"},
            language: "cn",
            //滑动验证长度配置
            customWidth: 300,
        }
        var script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = getProtocol + '//g.alicdn.com/sd/nvc/1.1.112/guide.js'
        document.getElementsByTagName('head')[0].appendChild(script)
        var timer = 0;
        timer = 0;
        script.onload = function () {
            if (typeof getNVCVal === 'function') {
                configParams.onloadCallback ? configParams.onloadCallback() : '';
            } else {
                timer = setInterval(function () {
                    if (typeof getNVCVal === 'function') {
                        clearInterval(timer)
                        configParams.onloadCallback ? configParams.onloadCallback() : '';
                    }
                }, 5)
            }
        };
        script.onerror = configParams.failCallback ? configParams.failCallback : '';
    },
    /*
    * @discribe 验证当前状态是否可以直接登录，如果可以使用快捷token登录，无需用户输入账号密码
    * @method checkToken
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象
    * */
    checkToken: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        _util.axiosPost(host + '/web/login/token',params)
    },
    
    /*
    * @discribe 验证当前状态是否可以直接登录，如果可以使用快捷token登录，无需用户输入账号密码
    * @method checkToken
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象
    * */
    tokenLogin: function (params) {
        this.checkToken(params)
    },
    /*
    * @discribe 展示滑块验证。
    * @method showSlide
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象
    * */
    showSlide: function (params) {
        if (!_util.validResHeader()) {
            var callback = params.failCallback ? params.failCallback : function (){};
            return callback(_util.getCode(1000000))
        }
        getNC().then(function(){
            if (isH5) {
                _nvc_nc.upLang('cn', {
                    'LOADING':"加载中",//加载
                    'SLIDER_LABEL': "按住滑块，拖动到最右边",//等待滑动
                    'CHECK_Y':"验证通过",//通过
                    'ERROR_TITLE':"非常抱歉，验证失败了",//拦截
                    'CHECK_N':"验证未通过", //准备唤醒二次验证
                    'OVERLAY_INFORM':"经检测你当前操作环境存在风险，请输入验证码",//二次验证
                });
                _nvc_nc.reset()
            } else {
                _nvc_nc.upLang('cn', {
                    _startTEXT: "按住滑块，拖动到最右边",
                    _yesTEXT: "验证通过",
                    _error300: "验证失败，点击<a href=\"javascript:__nc.reset()\">刷新</a>重试",
                    _errorNetwork: "网络不给力，请<a href=\"javascript:__nc.reset()\">点击刷新</a>",
                })
                _nvc_nc.reset()
            }
        })
        slideCallback = params.slideCallback;
        slideParams = getParams(params.slideParams);
        slidefailCallback = params.failCallback ? params.failCallback : function (){};
    },
    /*
    * @discribe 获取初始化数据
    * @method getInitData
    * */
    getInitData: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        _util.axiosGet(host + '/web/config/init', params)
    },
    /*
    * @discribe 退出登录。
    * @method loginOut
    * @param {params} 参数
    * */
    loginOut: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        _util.axiosGet(host + '/web/login/logout', params)
    },
    /*
    * @discribe 账号密码登录。
    * @method loginPassword
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象
    * */
    loginPassword: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        // 验证登录账号不能为空
        if (!_util.validNotEmpty(privateParams.data.symbol)) {
            params.success(_util.getCode(1010000));
            return
        }
        // 验证密码不能为空
        if (!_util.validNotEmpty(privateParams.data.password)) {
            params.success(_util.getCode(1010002));
            return
        }
        if(privateParams.data.is_second_verify != 1 && typeof getNVCVal === 'function') {
            // 非二次滑块验证，拼接无痕验证签名
            privateParams.data.invisible_sig = getNVCVal()
        }
        privateParams.data.source_type = 2
        privateParams.data.domain = domain
        _util.axiosPost(host + '/web/login/pwd', privateParams)
    },
     /*
    * @discribe 手机号验证码登录。
    * @method loginSms
    * @param {params} 登录参数
    * @return {Boolean} 返回一个Promise对象
    * */
    loginSms: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证手机号为空
         if (!_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010006));
            return
        }
        // 验证手机号合法性
        if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
            params.success(_util.getCode(1010007));
            return
        }
        // 验证手机验证码为空
        if (!_util.validNotEmpty(privateParams.data.sms_code)) {
            params.success(_util.getCode(1010008));
            return
        }
        // 验证手机号验证码合法性
        if (!_util.validVCode(privateParams.data.sms_code)) {
            params.success(_util.getCode(1010001));
            return
        }
        if(privateParams.data.is_second_verify != 1 && typeof getNVCVal === 'function') {
            // 非二次滑块验证，拼接无痕验证签名
            privateParams.data.invisible_sig = getNVCVal()
        }
        privateParams.data.source_type = 2
        privateParams.data.domain = domain
        _util.axiosPost(host + '/web/login/sms', privateParams)
    },
    /*
    * @discribe 登录获取手机验证码。
    * @method sendSMSCodeLogin
    * @param {params} 参数 type: 0 登录 1 找回密码 2 设置密码
    * @return {Boolean} 返回一个Promise对象
    * */
    sendSMSCodeLogin: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证手机号为空
         if (!_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010006));
            return
        }
        // 验证手机号合法性
        if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
            params.success(_util.getCode(1010007));
            return
        }
        if(privateParams.data.is_second_verify != 1 && typeof getNVCVal === 'function') {
            // 非二次滑块验证，拼接无痕验证签名
            privateParams.data.invisible_sig = getNVCVal()
        }
        _util.axiosPost(host + '/web/login/sms/send', privateParams)
    },
     /*
    * @discribe 密码、手机号修改获取验证码。
    * @method sendSMSCode
    * @param {params} 参数 type: 0 登录 1 找回密码 2 设置密码
    * @return {Boolean} 返回一个Promise对象
    * */
    sendSMSCode: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证手机号为空
        if ((privateParams.data.use == 4 || privateParams.data.use == 7) && !_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010012))
            return 
        }
        // 验证手机号合法性
        if ((privateParams.data.use == 4 || privateParams.data.use == 7) && !_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
            params.success(_util.getCode(1010011))
            return 
        }
        if(privateParams.data.is_second_verify != 1 && typeof getNVCVal === 'function') {
            // 非二次滑块验证，拼接无痕验证签名
            privateParams.data.invisible_sig = getNVCVal()
        }
        _util.axiosPost(host + '/web/security/sms', privateParams)
    },
     /*
    * @discribe 获取手机号地区码、仅支持大陆和香港
    * @method getPhoneCodeList
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    getPhoneCodeList: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        _util.axiosPost(host + '/web/phonecode/get', privateParams)
    },

    /*
    * @discribe 获取手机号国家码表（支持海外手机号）
    * @method getAllPhoneCodeList
    * @param {params} 参数
    * */
    getAllPhoneCodeList: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        _util.axiosPost(host + '/web/phonecode/foreign/get', privateParams)
    },

     /*
    * @discribe 获取是否绑定手机号和设置密码。
    * @method getSafeInfo
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    getSafeInfo: function (params) {
        var privateParams = getParams(params)
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        _util.axiosGet(host + '/web/security/info', privateParams)
    },
     /*
    * @discribe 获取用户主标识。
    * @method getSafeInfo
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    getMainSymbol: function (params) {
        var privateParams = getParams(params)
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        _util.axiosGet(host + '/web/acct/symbol', privateParams)
    },
     /*
    * @discribe 忘记密码，验证旧手机
    * @method checkPhone
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    checkPhone: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        // 验证类型不能为空
        if (!privateParams.data.type) {
            return params.success(_util.getCode(1010005))
        }
        if (privateParams.data.type == 4) {
            // 忘记密码
            privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
            // 验证手机号为空
            if (!_util.validNotEmpty(privateParams.data.phone)) {
                params.success(_util.getCode(1010012));
                return
            } 
            // 验证手机号合法性
            if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
                params.success(_util.getCode(1010011));
                return
            } 
        }
        // 验证验证码为空
        if (!_util.validNotEmpty(privateParams.data.vcode)) {
            params.success(_util.getCode(1010009));
            return
        }
        // 验证合法性
        if (!_util.validVCode(privateParams.data.vcode)) {
            params.success(_util.getCode(1010013));
            return
        }
        if(privateParams.data.is_second_verify != 1 && typeof getNVCVal === 'function') {
            // 非二次滑块验证，拼接无痕验证签名
            privateParams.data.invisible_sig = getNVCVal()
        }
        _util.axiosPost(host + '/web/security/cellphone/check', privateParams)
    },
    /*
    * @discribe 设置密码
    * @method setPassword
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * @TODO
    * */
    setPassword: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证密码为空
        if (!_util.validNotEmpty(privateParams.data.password)) {
            params.success(_util.getCode(1010014));
            return
        }
        // 验证密码合法性
        if (!_util.validPwd(privateParams.data.password)) {
            params.success(_util.getCode(1010015));
            return
        }
        // 验证手机号为空
        if (privateParams.data.type == 1 && !_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010012));
            return
        }
        // 验证手机号合法性
        if (privateParams.data.type == 1 && !_util.validPhone(privateParams.data.phone)) {
            params.success(_util.getCode(1010011));
            return
        }
        _util.axiosPost(host + '/web/security/password/set', privateParams)
    },
    /*
    * @discribe 新绑手机号
    * @method setPhone
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * @TODO
    * */
    setPhone: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证手机号为空
        if (!_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010012));
            return
        }
        // 验证手机号合法性
        if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
            params.success(_util.getCode(1010011));
            return
        }
        // 验证验证码为空
        if (!_util.validNotEmpty(privateParams.data.vcode)) {
            params.success(_util.getCode(1010009));
            return
        }
        // 验证验证码合法性
        if (!_util.validVCode(privateParams.data.vcode)) {
            params.success(_util.getCode(1010013));
            return
        }
        if(privateParams.data.is_second_verify != 1 && typeof getNVCVal === 'function') {
            // 非二次滑块验证，拼接无痕验证签名
            privateParams.data.invisible_sig = getNVCVal()
        }
        _util.axiosPost(host + '/web/security/cellphone/set', privateParams)
    },
    /*
    * @discribe 换绑手机号
    * @method changePhone
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * @TODO
    * */
    changePhone: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        // 验证手机号为空
        if (!_util.validNotEmpty(privateParams.data.phone)) {
            params.success(_util.getCode(1010012));
            return
        }
        // 验证手机号合法性
        if (!_util.validPhone(privateParams.data.phone, privateParams.data.phone_code)) {
            params.success(_util.getCode(1010011));
            return
        }
        // 验证验证码为空
        if (!_util.validNotEmpty(privateParams.data.vcode)) {
            params.success(_util.getCode(1010009));
            return
        }
        // 验证验证码合法性
        if (!_util.validVCode(privateParams.data.vcode)) {
            params.success(_util.getCode(1010016));
            return
        }
        // 验证TAG不能为空
        if (!_util.validNotEmpty(privateParams.data.tag)) {
            params.success(_util.getCode(1010003));
            return
        }
        if(privateParams.data.is_second_verify != 1 && typeof getNVCVal === 'function') {
            // 非二次滑块验证，拼接无痕验证签名
            privateParams.data.invisible_sig = getNVCVal()
        }
        _util.axiosPost(host + '/web/security/cellphone/update', privateParams)
    },
    /********* 用户信息相关 ********/ 
    /*
    * @discribe 获取用户信息
    * @method detailUser
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    detailUser: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        _util.axiosGet(host + '/web/user/info', getParams(params))
    },
    /*
    * @discribe 修改用户信息
    * @method modifyUserInfo
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    modifyUserInfo: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        var pattern = new RegExp("[`~!@#$%^&*()_\\-+=<>?:\"{}|,.\\/;'\\\\[\\]·~！@#￥%……&*（）——\\-+={}|《》？：“” 【】、；‘’，。、]", 'g');
        // 通行证验证
        if (privateParams.data.tal_name !== undefined) {
            if (pattern.test(privateParams.data.tal_name)) {
                return params.success(_util.getCode(1020000))
            }
            if (!/^[0-9a-zA-Z]{8,16}$/.test(privateParams.data.tal_name)) {
                return params.success(_util.getCode(1020000))
            }
            if (/^\d+$/.test(privateParams.data.tal_name)) {
                return params.success(_util.getCode(1020000))
            }
        }
        // 昵称验证
        if (privateParams.data.nickname !== undefined) {
            if (pattern.test(privateParams.data.nickname)) {
                return params.success(_util.getCode(1020001))
            }
            if (privateParams.data.nickname.length > 32) {
                return params.success(_util.getCode(1020001))
            }
            if (_util.validEmpty(privateParams.data.nickname)) {
                return params.success(_util.getCode(1020001))
            }
        }
        // 真实姓名验证
        if (privateParams.realname !== undefined) {
            var regName = /^[a-z0-9A-Z&\-,（）(). \u4e00-\u9fa5]+$/;
            if (!regName.test(privateParams.data.realname)) {
                return params.success(_util.getCode(1020002))
            }
            /*验证32位*/
            if (privateParams.data.realname.length > 32) {
                return params.success(_util.getCode(1020002))
            }
            if (_util.validEmpty(privateParams.data.realname)) {
                return params.success(_util.getCode(1020002))
            }
        }
        // 英文名验证
        /*k可以多位空格*/
        if (privateParams.data.en_name !== undefined) {
            var enreg = /^[a-zA-Z ]+$/;
            if (!enreg.test(privateParams.data.en_name)) {
                return params.success(_util.getCode(1020003))
            }
            if (privateParams.data.en_name.length > 32) {
                return params.success(_util.getCode(1020003))
            }
            if (_util.validEmpty(privateParams.data.en_name)) {
                return params.success(_util.getCode(1020003))
            }
        }
        // 生日验证
        if (privateParams.data.birthday !== undefined) {
            // var regBir = /^\d{4}-\d{2}-\d{2}$/;
            var regBir = /^\d{4}-([0][123456789]|[1][012])-([012][123456789]|[3][01])$/;
            if (!regBir.test(privateParams.data.birthday)) {
                return params.success(_util.getCode(1020004))
            }
        }
        // 入学年级验证
        if (privateParams.data.school_year !== undefined) {
            var regBir = /^\d{4}$/;
            if (!regBir.test(privateParams.data.school_year)) {
                return params.success(_util.getCode(1020005))
            }
        }
        // 地区校验
        if (privateParams.data.province > 0) {
            if (privateParams.data.city <= 0) {
                return params.success(_util.getCode(1040001))
            }
        }
        _util.axiosPost(host + '/web/user/modify', privateParams)
    },
    /*
    * @discribe 上传用户头像
    * @method uploadPhoto
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    uploadPhoto: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var allowArr = ['png', 'jpg', 'jpeg', 'gif'];
        var type = params.data.avatar.type
        var imgType = type.split('/')[1]
        if (allowArr.indexOf(imgType.toLocaleLowerCase()) == -1) {
            return params.success(_util.getCode(1020006))
        }
        var formData = new FormData();
        for (var i in params.data) {
            formData.append(i, params.data[i])
        }
        params.data = formData
        _util.axiosPost(host + '/web/user/avatar', params, 'formdata', reqMultipart)
    },
    /*
    * @discribe 新增收货地址
    * @method createAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    createAddress: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        var nameLen = privateParams.data.name ? privateParams.data.name.length : 0;
        // 验证收货人姓名为空
        if (_util.validEmpty(privateParams.data.name)) {
            return params.success(_util.getCode(1030005))
        }
        // 验证收货人姓名合法性
        if (nameLen < 1 || nameLen > 32 || (!/^[a-z0-9A-Z&\-,（）(). \u4e00-\u9fa5]+$/.test(privateParams.data.name))) {
            return params.success(_util.getCode(1030001))
        }
        /*不支持香港只验证大陆*/
        // 验证手机号为空
        if (_util.validEmpty(privateParams.data.phone)) {
            return params.success(_util.getCode(1030006))
        }
        // 验证手机号的合法性
        if (!_util.validPhone(privateParams.data.phone, '86')) {
            return params.success(_util.getCode(1030007))
        }
        // 验证省份信息为空
        if (!privateParams.data.province) {
            return params.success(_util.getCode(1040003))
        }
        // 验证省份信息合法性
        if (privateParams.data.province <= 0) {
            return params.success(_util.getCode(1040000))
        }
        // 验证城市信息为空
        if (!privateParams.data.city) {
            return params.success(_util.getCode(1040004))
        }
        // 验证城市信息合法性
        if (privateParams.data.city <= 0) {
            return params.success(_util.getCode(1040001))
        }
        // 验证区县信息为空
        if (!privateParams.data.county) {
            return params.success(_util.getCode(1040005))
        }
        // 验证区县信息合法性
        if (privateParams.data.county <= 0) {
            return params.success(_util.getCode(1040002))
        }
        // 验证收货地址详细信息为空
        if (_util.validEmpty(privateParams.data.detail)) {
            return params.success(_util.getCode(1030008))
        }
        // 验证收货地址详细信息合法性
        if (privateParams.data.detail.length > 100) {
            return params.success(_util.getCode(1030003))
        }
        // 验证备注信息长度合法性
        if (privateParams.data.remark) {
            if (_util.trim(privateParams.data.remark).length > 100) {
                return params.success(_util.getCode(1030004))
            }
        }
        _util.axiosPost(host + '/web/address/create', privateParams)
    },
    /*
    * @discribe 获取地址列表
    * @method listAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    listAddress: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        _util.axiosGet(host + '/web/address/list', privateParams)
    },
    /*
    * @discribe 获取地址信息
    * @method listAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    infoAddress: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        // 地址id非空校验
        if (!privateParams.data.addr_id) {
            return params.success(_util.getCode(1030000))
        }
        _util.axiosPost(host + '/web/address/info', privateParams)
    },
    /*
    * @discribe 修改地址
    * @method modifyAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    modifyAddress: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        privateParams.data.phone_code = privateParams.data.phone_code ? privateParams.data.phone_code : '86'
        var nameLen = privateParams.data.name ? privateParams.data.name.length : 0;
        // 验证收货人姓名为空
        if (_util.validEmpty(privateParams.data.name)) {
            return params.success(_util.getCode(1030005))
        }
        // 验证收货人姓名合法性
        if (nameLen < 1 || nameLen > 32 || (!/^[a-z0-9A-Z&\-,（）(). \u4e00-\u9fa5]+$/.test(privateParams.data.name))) {
            return params.success(_util.getCode(1030001))
        }
        /*不支持香港只验证大陆*/
        // 验证手机号为空
        if (_util.validEmpty(privateParams.data.phone)) {
            return params.success(_util.getCode(1030006))
        }
        // 验证手机号的合法性
        if (!_util.validPhone(privateParams.data.phone, '86')) {
            return params.success(_util.getCode(1030007))
        }
        // 验证省份信息为空
        if (!privateParams.data.province) {
            return params.success(_util.getCode(1040003))
        }
        // 验证省份信息合法性
        if (privateParams.data.province <= 0) {
            return params.success(_util.getCode(1040000))
        }
        // 验证城市信息为空
        if (!privateParams.data.city) {
            return params.success(_util.getCode(1040004))
        }
        // 验证城市信息合法性
        if (privateParams.data.city <= 0) {
            return params.success(_util.getCode(1040001))
        }
        // 验证区县信息为空
        if (!privateParams.data.county) {
            return params.success(_util.getCode(1040005))
        }
        // 验证区县信息合法性
        if (privateParams.data.county <= 0) {
            return params.success(_util.getCode(1040002))
        }
        // 验证收货地址详细信息为空
        if (_util.validEmpty(privateParams.data.detail)) {
            return params.success(_util.getCode(1030008))
        }
        // 验证收货地址详细信息合法性
        if (privateParams.data.detail.length > 100) {
            return params.success(_util.getCode(1030003))
        }
        // 验证备注信息长度合法性
        if (privateParams.data.remark) {
            if (_util.trim(privateParams.data.remark).length > 100) {
                return params.success(_util.getCode(1030004))
            }
        }
        _util.axiosPost(host + '/web/address/modify', privateParams)
    },
    /*
    * @discribe 设置默认地址
    * @method defaultAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    defaultAddress: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        params.data.is_default = '1'
        var privateParams = getParams(params);
        // 地址id非空校验
        if (!privateParams.data.addr_id) {
            return params.success(_util.getCode(1030000))
        }
        _util.axiosPost(host + '/web/address/modify', privateParams)
    },
    /*
    * @discribe 取消默认地址
    * @method defaultAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    cancelAddress: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        params.data.is_default = '2'
        var privateParams = getParams(params);
        // 地址id非空校验
        if (!privateParams.data.addr_id) {
            return params.success(_util.getCode(1030000))
        }
        _util.axiosPost(host + '/web/address/modify', privateParams)
    },
    /*
    * @discribe 删除地址
    * @method delAddress
    * @param {params} 参数
    * @return {Boolean} 返回一个Promise对象
    * */
    delAddress: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params);
        // 地址id非空校验
        if (!privateParams.data.addr_id) {
            return params.success(_util.getCode(1030000))
        }
        _util.axiosPost(host + '/web/address/del', privateParams)
    },
    /********* 地区信息省市区相关 ********/
    /*
    * @discribe 获取省信息
    * @method getProvinces
    * @param {params} 参数
    * @return {Promise} 返回一个Promise对象
    * */
    getProvinces: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        _util.axiosGet(host + '/web/area/province/list', privateParams)
    },
    /*
    * @discribe 根据省id获取市信息
    * @method getCity
    * @param {params} 参数
    * @return {Promise} 返回一个Promise对象
    * */
    getCitys: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        if (!_util.validNotEmpty(privateParams.data.province_id)) {
            return params.success(_util.getCode(1040003))
        }
        _util.axiosGet(host + '/web/area/city/list', privateParams)
    },
    /*
    * @discribe 根据市id获取区县信息
    * @method getCounty
    * @param {params} 参数
    * @return {Promise} 返回一个Promise对象
    * */
    getCounty: function (params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        if (!_util.validNotEmpty(privateParams.data.citie_id)) {
            return params.success(_util.getCode(1040004))
        }
        _util.axiosGet(host + '/web/area/county/list', privateParams)
    },

    /*
    * @discribe 检测是否需要设置心跳
    * @param {params} 参数
    * */
    isHeartbeat: function(params) {
        if (!_util.validResHeader()) return params.success(_util.getCode(1000000))
        var privateParams = getParams(params)
        _util.axiosGet(host + '/web/heartbeat/check', privateParams)

    },

    /*
    * @discribe 心跳接口
    * @param {params} 参数
    * */
    checkHeartbeat: function(params) {
        if (!_util.validResHeader()) return (params.success ? params.success(_util.getCode(1000000)): '')
        var privateParams = getParams(params)
        _util.axiosPost(host + '/web/login/status/check', privateParams)
    },
    
    /*
    * @discribe 检测是否开启心跳
    * @param {params} 参数
    * */
    isOpenHeartbeat: function () {
        let _t = this
        let checkDelayTime = 10*1000
        /* 1. 10s请求一次判断是否登录
         * 2. 登录成功之后开启5分钟发送一次心跳，并且关闭10s的请求
         * 3. 5分钟发送一次的心跳如果返回tal-token即在登录状态，则不作任何处理，否则就是登录态失败，需要重新开启10s请求一次判断是否登录，并且关闭5分钟发送一次心跳
        */
        checkHeartbeatFlag = window.setInterval(function() {
            _t.checkHeartbeat({
                success: function(msg) {
                    if (msg.errcode == 0) {
                        window.clearInterval(checkHeartbeatFlag)
                        // 成功之后5分钟请求一次心跳接口
                        setHeartbeatFlag = window.setInterval(function(){
                            _t.checkHeartbeat({
                                success: function(res) {
                                    // 5分钟之后的请求成功之后不做任何处理，失败的话就是登陆失效，需要转换为10s请求一次心跳接口
                                    if (res.errcode != 0) {
                                        window.clearInterval(setHeartbeatFlag)
                                        _t.isOpenHeartbeat()
                                    }
                                }
                            })
                        }, 5*60*1000)
                    }
                }
            })
        }, checkDelayTime)
    },

    /*
    * @discribe 设置心跳方法
    * */
    setCheckHeartbeat: function() {
        var _t = this
        // 判断是否需要设置心跳
        _t.isHeartbeat({
            success: function (res) {
                // errcode为0时，isHeartBeat为1标识启动心跳，为0标识不启动心跳
                if (res.errcode == 0 && res.data.isHeartBeat == 1) {
                    // 判断是否登录，登录之后才可以开启5分钟心跳一次，否则10s检查一次是否登录成功
                    _t.isOpenHeartbeat()
                }
            }
        })
    }
    // getAllArea: function (params) {
    //     if (!_util.validResHeader()) params.success(_util.getCode(1000000))
    //     return params.success({
    //         'errcode': 0,
    //         'errmsg': '请求成功',
    //         'data': allArea
    //     })
    // }
}
window.TAL_UC = TAL_UC;
module.exports = TAL_UC;
// Allow use of default import syntax in TypeScript
export default TAL_UC;










// WEBPACK FOOTER //
// ./src/index.js